export default "__VITE_ASSET__ae6d1cd0__"